import type { StoreCode } from "../libs/models/shopify/storeCodeSchema";

/**
 * 顧客向けメールで名乗る差出人名。本文末尾の署名と、送信時の From 表示名で同じ文字列を使う
 * (メール上で名乗りが 2 通りあると別の窓口があるように見えるため)。
 */
export const CUSTOMER_SUPPORT_NAME = "サバキュー カスタマーサポート";

/** 顧客向けメールで名乗るストア名。顧客が実際に購入したサイトの名前に揃える。 */
export const storeName: Record<"ja", Record<StoreCode, string>> = {
  ja: {
    survaq: "SurvaQストア",
    calqs: "CALQS公式サイト",
  },
};
